/* eslint-disable */
import { WindowTitle } from "@saleor/components/WindowTitle";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { sectionNames } from "@saleor/intl";
import { ProductTagsTagType, TagTypeEnum } from "@saleor/types/globalTypes";
import React from "react";
import { useIntl } from "react-intl";

import {
  // decimal,
  // joinDateTime,
  maybe
} from "../../misc";
// import { DiscountValueTypeEnum, SaleType } from "../../types/globalTypes";
import SaleCreatePage from "../components/productCreatePage";
import { TypedCreateProducttags } from "../mutations";
import { CreateProducttags } from "../types/CreateProducttags";
import { producttagsListUrl, productTageseUrl } from "../urls";

// function discountValueTypeEnum(type: SaleType): DiscountValueTypeEnum {
//   return type.toString() === DiscountValueTypeEnum.FIXED
//     ? DiscountValueTypeEnum.FIXED
//     : type.toString() === DiscountValueTypeEnum.CUSTOM
//     ? DiscountValueTypeEnum.CUSTOM
//     : DiscountValueTypeEnum.PERCENTAGE;
// }
export function TagValueTypeEnum(type: ProductTagsTagType): TagTypeEnum {
  return type.toString() === TagTypeEnum.TEXT
    ? TagTypeEnum.TEXT
    : TagTypeEnum.IMAGE;
}
export const SaleDetails: React.FC = () => {
  const navigate = useNavigator();
  const pushMessage = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const handleSaleCreate = (data: CreateProducttags) => {
    if (data.producttagsCreate.errors.length === 0) {
      pushMessage({
        text: intl.formatMessage({
          defaultMessage: "Successfully created sale"
        })
      });
      navigate(productTageseUrl(data.producttagsCreate.productTags.id), true);
    }
  };

  return (
    <TypedCreateProducttags onCompleted={handleSaleCreate}>
      {(saleCreate, saleCreateOpts) => (
        <>
          <WindowTitle title={intl.formatMessage(sectionNames.sales)} />
          <SaleCreatePage
            defaultCurrency={maybe(() => shop.defaultCurrency)}
            disabled={saleCreateOpts.loading}
            errors={saleCreateOpts.data?.producttagsCreate.errors || []}
            onBack={() => navigate(producttagsListUrl())}
            onSubmit={formData =>
              saleCreate({
                variables: {
                  input: {
                    // endDate: formData.hasEndDate
                    //   ? joinDateTime(formData.endDate, formData.endTime)
                    //   : null,
                    tagType: TagValueTypeEnum(formData.tagType),
                    title: formData.title,
                    name: formData.name,
                    stickersImage: formData.stickersImage,
                    stickersImageLocationX: formData.stickersImageLocationX,
                    stickersImageLocationY: formData.stickersImageLocationY,
                    showTag: formData.showTag,
                    componentFontColor: formData.componentFontColor,
                    productFontColor: formData.productFontColor,
                    productBackgroundColor: formData.productBackgroundColor

                    // startDate: joinDateTime(
                    //   formData.startDate,
                    //   formData.startTime
                    // ),
                    // type: discountValueTypeEnum(formData.type),
                    // value: decimal(formData.value)
                  }
                }
              })
            }
            saveButtonBarState={saleCreateOpts.status}
          />
        </>
      )}
    </TypedCreateProducttags>
  );
};
export default SaleDetails;
